import { useState } from 'react';
import { Link } from 'react-router-dom';

import { Gate } from '../../../global/contexts/auth/auth';
import { IconScale } from '../../../common/icons';
import { useAnimalStats } from '../../stats/contexts/stats';
import ValuationForm from '../forms/valuation-form';

import '../../../common/styles/catalog.css';
import './styles/offspring-panel.css';

// Crías (vivas) paridas de la donadora: bloque `offspring` del stats de donante
// (admin-stats.md · GET /admin/animals/:id/stats). Son las crías POR GENEALOGÍA
// (madre = ella); `items` = las que tienen ficha de animal (registradas/activas).
// admin/births no filtra por donadora, así que ésta es la vía. Cada cría enlaza al
// formulario de AVALÚO (0098, animals:write). Lo demás read-only, kpis:read.
const SEX = { female: 'Hembra', male: 'Macho' };

export default function DonorOffspringPanel({ animalId }) {
    const { data, isLoading, error } = useAnimalStats(animalId);
    const [valuing, setValuing] = useState(null); // cría a avaluar (abre ValuationForm)

    const off = data?.offspring || {};
    const items = off.items || [];
    const count = off.count ?? items.length;
    const registered = off.registered ?? items.length;

    return (
        <section className="cat-detail__card">
            <div className="doff__head">
                <h2 className="cat-detail__section-title">Crías</h2>
                {!isLoading && !error && <span className="doff__count">{registered}</span>}
            </div>

            {error ? (
                <p className="doff__muted">{error.status === 403 ? 'Sin permiso para ver las crías.' : (error.message || 'No se pudieron cargar las crías.')}</p>
            ) : isLoading ? (
                <p className="doff__muted">Cargando crías…</p>
            ) : !items.length ? (
                <p className="doff__muted">{count > 0 ? `${count} cría(s) nacida(s), sin ficha registrada.` : 'Sin crías registradas.'}</p>
            ) : (
                <>
                    <table className="cat-table cat-table--compact">
                        <thead>
                            <tr><th>Cría</th><th>Número</th><th>Registro</th><th>Sexo</th><th aria-label="Acciones" /></tr>
                        </thead>
                        <tbody>
                            {items.map((c) => (
                                <tr key={c.id} className="cat-table__row">
                                    <td><Link to={`/admin/animals/${c.id}`} className="cat-table__name">{c.name || c.number || `#${c.id}`}</Link></td>
                                    <td>{c.number || <span className="cat-table__empty">—</span>}</td>
                                    <td>{c.register || <span className="cat-table__empty">—</span>}</td>
                                    <td>{SEX[c.sex] || <span className="cat-table__empty">—</span>}</td>
                                    <td className="doff__actions">
                                        <Gate domain="animals" action="write">
                                            <button type="button" className="doff__val" onClick={() => setValuing(c)} title="Avaluar" aria-label={`Avaluar ${c.name || c.number || c.id}`}>
                                                <IconScale /> <span>Avaluar</span>
                                            </button>
                                        </Gate>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    {count > registered && <p className="doff__muted">{registered} con ficha de {count} nacida(s).</p>}
                </>
            )}

            {valuing && <ValuationForm subject={{ kind: 'animals', id: valuing.id, label: valuing.name || valuing.number || `#${valuing.id}` }} onClose={() => setValuing(null)} onSaved={() => setValuing(null)} />}
        </section>
    );
}
